import React from 'react';
type Props = {
  color: string;
  style?: React.CSSProperties;
};
const Indicator = ({ color, style }: Props) => (
  <>
    <span
      style={{
        width: 8,
        height: 55,
        backgroundColor: color,
        borderRadius: '8px 0px 0px 8px',
        marginRight: -8,
        opacity: 0.5,
        ...style
      }}
    />
  </>
);

export default Indicator;
